import styled from 'styled-components';
import them from 'common/theme';

export const LineStatusWidgetContainer = styled.div`
.widget-ui__icon-right-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}
.widget-ui__icon-right {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  border-radius: 4px;
  border: 0.5px solid ${them.colors.mainColor};
  background: ${them.colors.gray200};
  box-shadow: 0px 0px 4px 0px rgba(0, 118, 204, 0.24) inset, 0px 0px 4px 0px rgba(0, 118, 204, 0.19);
}

.line-status-and-image-container {
  display: flex;
  padding: 1rem;
  flex-direction: row;
  gap: 1.5rem;
}
`;

export const StyledModalContentContainer = styled.div`
  padding: 0rem 3rem 1.5rem;
`;
